import { ThemeProvider } from "styled-components";
import { theme } from "./styles/theme";
import Footer from "./components/Footer";
import Header from "./components/Header";
import NavBar from "./components/NavBar";
import { PageWrapper } from "./styles/Layouts";
import { MainImage } from "./styles/Images";
import Hero from "./components/Hero";

const NewApp = () => {
  return (
    <ThemeProvider theme={theme}>
      <PageWrapper>
        <MainImage />
        <NavBar />
        <Hero />
        <Footer />
      </PageWrapper>
    </ThemeProvider>
  );
};

export default NewApp;
